module.exports = new __parcel__URL__("file-cabinet.6176e2f0.svg").toString();